import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { navCategoryFeatured as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    rebateOptions: {
      hideElevationCurrency: true,
    },
    seeAllLinkPrefix: 'See all',
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
